export default __webpack_public_path__ + "static/media/xero-partner-badge-CMYK.01524c32.jpg";